import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { Quotation } from 'src/app/shared/models/quotation.model';
import { OrderDataService } from 'src/app/shared/data-service/order-data.service';
import { QuotationCommercialItem, QuotationDetailsComponent } from 'projects/dop-ordering/src/public-api';
import QuotationDetailsHelper from 'projects/dop-ordering/src/lib/features/quotation-details/quotation-details.helper';
import { DialogService } from 'primeng/dynamicdialog';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-quotation',
  templateUrl: './quotation.component.html',
  styleUrls: ['./quotation.component.scss']
})
export class QuotationComponent implements OnChanges {

  @Input() options: Quotation[];
  @Input() selectedValue: Quotation;
  @Output() selection = new EventEmitter();

  selectedOption: Quotation;
  quotation: any;
  quotationDetails: QuotationCommercialItem;
  hoveredQuotation: string;
  constructor(
    private dialogService: DialogService,
    private orderDataService: OrderDataService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.options) {
      this.options = this.getSortedOptions();
    }
  }

  onQuotationSelection(event: any) {
    if (event.originalEvent.srcElement.tagName === 'SPAN') {
      this.selectedOption = this.selectedValue;
      this.selectedValue = event.option;
      this.selection.emit(event.option);
    } else {
      this.selectedValue = {};
    }
  }

  openToolTip(event: Event, overlayReference: OverlayPanel, data: Quotation) {
    overlayReference.hide();
    setTimeout(() => {
      this.hoveredQuotation = data.code;
      this.loadQuotedItemsOnHover(data);
      overlayReference.show(event);
    }, 500);
  }

  openPdf(data: Quotation) {
    this.orderDataService.getQuotedItemsPDF(data.accountCode, data.code).subscribe(blobResp => {
      const pdfUrl = window.URL.createObjectURL(blobResp);
      window.open(pdfUrl, '_blank');
    });
  }

  onHide() {
    this.hoveredQuotation = '';
  }

  loadQuotedItemsOnHover(data: Quotation) {
    this.orderDataService.getSortedQuotedItems(data.accountCode, data.code).subscribe(c => {
      this.quotation = c.sortedQuotedItems;
    });
  }

  getSortedOptions() {
    if (this.options) {
      this.options.sort((a, b) => {
        if (a.name === b.name) {
          if (a.salesPartnerName === b.salesPartnerName) {
            return a.code > b.code ? 1 : -1;
          }
          return a.salesPartnerName > b.salesPartnerName ? 1 : -1;
        }
        return a.name > b.name ? 1 : -1;
      });
    }
    return this.options;
  }
}
